import { BaseApiClient } from './base-client'
import type { ContactWithRelationships, ApiResponse } from '@super/shared-types'
import { API_ROUTES, interpolateRoute } from '@super/shared-types'
import { normalizeContacts } from '../utils/contacts/normalize-contacts'

/**
 * Contacts API Client
 */
export class ContactsApiClient extends BaseApiClient {
  /**
   * Get all contacts for a company (SuperAdmin only)
   * @param companyId - The ID of the company to get contacts for
   * @returns The contacts for the company
   */
  async getAllAdminContactsForCompany(
    companyId: string,
  ): Promise<ContactWithRelationships[]> {
    const route = interpolateRoute(API_ROUTES.ADMIN.CONTACTS.GET_BY_COMPANY, {
      companyId,
    })
    const response = await this.request<
      ApiResponse<ContactWithRelationships[]>
    >(route, { method: 'GET' })
    return normalizeContacts(response.data || [])
  }

  // Tenant-scoped read for the authed user's company — no super-admin guard.
  async listForAuthedCompany(): Promise<ContactWithRelationships[]> {
    const response = await this.request<
      ApiResponse<ContactWithRelationships[]>
    >(API_ROUTES.CONTACTS.LIST, { method: 'GET' })
    return normalizeContacts(response.data || [])
  }
}

// Create singleton instance
export const contactsApiClient = new ContactsApiClient()
